import { toaster } from 'uikit/Toaster'
import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useFetchDocument = (id: string) => {
  const response = useQuery({
    queryKey: ['document', id],
    queryFn: () => api.documents.fetchItem(id),
    enabled: !!id,
  })

  if (response.isError) {
    toaster.create({
      title: 'Не удалось загрузить данные документа',
      description: response.error?.message,
      type: 'error',
      duration: 9000,
      isClosable: true,
    })
  }

  return response
}
